// extracted by mini-css-extract-plugin
export default {"wrapper":"labeledIconLayoutStyles_wrapper__8NjLN"};